import { fabric } from "fabric";
import { isBlackoutLabelName } from "@/utils/textLabels";

/** Semi-transparent fill used for the annotation body. */
export function annotationFillRgba(color_values) {
    return 'rgba(' + color_values[0] + ',' + color_values[1] + ',' + color_values[2] + ',0.1)';
}

/** Blackout labels always render as solid black regardless of their stored color. */
export function resolvedColorValues(annotation) {
    if (isBlackoutLabelName(annotation.label)) {
        return [0, 0, 0];
    }
    if (annotation.color_values && annotation.color_values.length >= 3) {
        return annotation.color_values;
    }
    if (annotation.color) {
        return annotation.color.split(',');
    }
    return [0, 180, 0];
}

export function annotationFillFor(annotation, color_values) {
    if (isBlackoutLabelName(annotation.label)) {
        return 'rgba(0,0,0,0.72)';
    }
    return annotationFillRgba(color_values);
}

export function annotationGlowFor(annotation, color_values, zoom = 1) {
    if (isBlackoutLabelName(annotation.label)) {
        return null;
    }
    return annotationGlowShadow(color_values, zoom);
}

export function annotationGlowShadow(color_values, zoom = 1) {
    const z = Math.max(zoom, 0.01);
    return new fabric.Shadow({
        color: 'rgba(' + color_values[0] + ',' + color_values[1] + ',' + color_values[2] + ',0.42)',
        blur: 6 / z,
        offsetX: 0,
        offsetY: 0,
    });
}

/** Pick a readable label text color (dark on light backgrounds, white on dark). */
export function labelTextFill(color_values) {
    const r = color_values[0];
    const g = color_values[1];
    const b = color_values[2];
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 165 ? '#1a1a1a' : '#ffffff';
}
